// 行业名称映射工具
// 将 dataConfig.ts 中的行业键映射到国际化翻译键

/**
 * 行业键映射表
 * 将数据配置中的行业键映射到国际化翻译键
 */
export const INDUSTRY_KEY_MAPPING: Record<string, string> = {
  // 根据 dataConfig.ts 中的实际 name 字段映射
  '信息技术与软件': 'industries.infoTech',
  '媒体与内容创作': 'industries.media',
  '金融服务': 'industries.financeServices',
  '医疗健康与生命科学': 'industries.healthcareLife',
  '制造与工业': 'industries.manufacturingIndustrial',
  '零售与电子商务': 'industries.retailEcommerce',
  '交通与物流': 'industries.transportationLogistics',
  '专业服务': 'industries.professionalServices',
  '教育': 'industries.education',
  '科学研究': 'industries.scientificResearch',
  '能源与公共事业': 'industries.energyUtilities',
  '政府与公共部门': 'industries.publicSector',
  // 兼容性映射，处理其他可能的变体
  'infoTech': 'industries.infoTech',
  'media': 'industries.media',
  'finance': 'industries.financeServices',
  'healthcare': 'industries.healthcareLife',
  'manufacturing': 'industries.manufacturingIndustrial',
  'retail': 'industries.retailEcommerce',
  'transportation': 'industries.transportationLogistics',
  'professionalServices': 'industries.professionalServices',
  'education': 'industries.education',
  'scientificResearch': 'industries.scientificResearch',
  'energy': 'industries.energyUtilities',
  'publicSector': 'industries.publicSector',
};

/**
 * 获取行业名称的国际化键
 * @param industryName - 来自数据配置的行业名称
 * @returns 对应的国际化键
 */
export function getIndustryI18nKey(industryName: string): string {
  return INDUSTRY_KEY_MAPPING[industryName] || `industries.${industryName.toLowerCase().replace(/\s+/g, '')}`;
}

/**
 * 判断是否为已知行业
 * @param industryName - 行业名称
 * @returns 是否为已知行业
 */
export function isKnownIndustry(industryName: string): boolean {
  return Object.prototype.hasOwnProperty.call(INDUSTRY_KEY_MAPPING, industryName);
} 